import {
  ContextTypes,
  ENTERPRISE_CONTEXT_TYPE,
  PERSONAL_CONTEXT_TYPE,
} from './ContextTypes';

export default class DashboardContext {
  constructor({ type, id, name, isOwner }) {
    if (!ContextTypes.includes(type)) {
      throw new Error(`Choose a context type from ${ContextTypes}`);
    }
    this.type = type;
    if (type === ENTERPRISE_CONTEXT_TYPE) {
      this.id = id;
      this.name = name;
      this.isOwner = isOwner;
    }
  }

  isPersonal() {
    return this.type === PERSONAL_CONTEXT_TYPE;
  }

  isEnterprise() {
    return this.type === ENTERPRISE_CONTEXT_TYPE;
  }
}



// WEBPACK FOOTER //
// ./app/actions/context/DashboardContext.js